import React from 'react';
import { ArrowRight } from 'lucide-react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import { scrollToSection } from '../utils/smoothScroll';

const BlogSection = () => {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [cardsRef, cardsVisible] = useScrollAnimation();

  return (
    <section id="method" className="bg-[#0b114e] py-24 lg:py-32 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-20 right-20 w-72 h-72 bg-[#d4883a]/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-white/5 rounded-full blur-3xl" />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative">
        {/* Header */}
        <div 
          ref={headerRef}
          className={`text-center mb-20 animate-on-scroll ${headerVisible ? 'animated' : ''}`}
        >
          <p className="text-[#d4883a] font-semibold mb-4 tracking-wide">Il mio metodo</p>
          <h2 
            className="text-4xl lg:text-6xl text-white leading-tight mb-6"
            style={{ fontFamily: 'Georgia, serif' }}
          >
            Il Framework{' '}
            <span className="text-[#d4883a]">D.O.M.I.N.A.</span>
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Un metodo proprietario sviluppato in 14 anni di esperienza sul campo, testato su oltre 45 aziende con un tasso di successo dell'89%.
          </p>
        </div>

        {/* Method Steps */}
        <div ref={cardsRef} className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { letter: 'D', title: 'Diagnosi', desc: 'Analisi profonda del tuo business, mercato e competitor per identificare le vere leve di crescita.' },
            { letter: 'O', title: 'Obiettivi', desc: 'Definizione di KPI chiari e misurabili. Saprai esattamente dove stai andando e come misurare il successo.' },
            { letter: 'M', title: 'Mappa', desc: 'Strategia dettagliata con roadmap trimestrale. Ogni azione è pianificata e prioritizzata.' },
            { letter: 'I', title: 'Implementazione', desc: 'Esecuzione guidata con il mio supporto diretto. Non ti lascio solo con un PDF.' },
            { letter: 'N', title: 'Numeri', desc: 'Monitoraggio costante delle metriche. Decisioni basate su dati, non su sensazioni.' },
            { letter: 'A', title: 'Accelerazione', desc: 'Ottimizzazione continua e scaling delle strategie vincenti. Crescita esponenziale.' },
          ].map((step, index) => (
            <div 
              key={index}
              className={`group bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-[#d4883a]/50 transition-all duration-300 hover:-translate-y-1 animate-on-scroll stagger-${index + 1} ${cardsVisible ? 'animated' : ''}`}
            >
              <span className="text-6xl font-bold text-[#d4883a]/20 group-hover:text-[#d4883a]/40 transition-colors">
                {step.letter}
              </span>
              <h3 className="text-xl font-bold text-white mt-2 mb-3">{step.title}</h3>
              <p className="text-white/60 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <button
            onClick={() => scrollToSection('contact')}
            className="inline-flex items-center gap-2 bg-[#d4883a] hover:bg-[#d4896a] text-white font-semibold px-8 py-4 rounded-full transition-all"
          >
            Scopri come applicarlo alla tua azienda
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
